export enum ComoTransactionOperations {
	AddPoints = 'AddPoints',
	RemovePoints = 'RemovePoints',
}
